import React, { useEffect, useRef } from 'react';


const AutoShowComponent = ({srcImg, altImg, width, height}) => {
    const autoShowRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    } else {
                        entry.target.classList.remove('visible');
                    }
                });
            },
            {
                threshold: 0.1, 
            }
        );

        const element = autoShowRef.current;
        if (element) observer.observe(element);

        return () => {
            if (element) observer.unobserve(element);
        };
    }, []);

    return (
        <div ref={autoShowRef} className="auto-show">
            <div className="img img-200">
                <img src={srcImg} alt={altImg} width={width} height={height}/>
            </div>
        </div>
    );
};

export default AutoShowComponent;
